import GatewayTimeoutAlertBody from './GatewayTimeoutAlertBody';

export default GatewayTimeoutAlertBody;
